import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  listAll() {
    return axios.get('/v1/industries/')
  },
})
